// extracted by mini-css-extract-plugin
export var attachment = "_qt-a";
export var emailContainer = "_qt-4";
export var emailContentPaddedContainer = "_qt-b";
export var emailHeader = "_qt-6";
export var emailIframe = "_qt-3";
export var emailInfoIcon = "_qt-9";
export var emailShortenedSummary = "_qt-e";
export var infoDropdown = "_qt-0";
export var infoRowBoundedContent = "_qt-d";
export var internal = "_qt-5";
export var merchant = "_qt-8";
export var messageInputContainer = "_qt-h";
export var normal = "_qt-7";
export var replyCard = "_qt-f";
export var subtleButton = "_qt-1";
export var subtleButtonIconContainer = "_qt-2";
export var toggleViewRepliesButton = "_qt-c";
export var wrappingText = "_qt-g";